import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-482fca30"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "foot" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", { class: "d-md-none" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_4 = ["href"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "mailto:service@silverfish.cc" }, "service@silverfish.cc", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("small", null, [
      _createTextVNode(" 本站所有圖文影來源皆為其他網站，"),
      _hoisted_2,
      _createTextVNode("且針對所有內容未進行任何儲存。"),
      _hoisted_3,
      _createTextVNode(" Version   "),
      _createElementVNode("a", {
        href: `https://github.com/jackey8616/Silverfish-Vue/commit/${_ctx.lastUpdateMasterHash}`,
        target: "_blank"
      }, _toDisplayString(_ctx.lastUpdateMasterHash.slice(0, 7)), 9, _hoisted_4),
      _hoisted_5,
      _createTextVNode(" Updated @ " + _toDisplayString(_ctx.lastUpdateMasterTime), 1),
      _hoisted_6,
      _createTextVNode(" Built @ " + _toDisplayString(_ctx.lastDeployTime), 1),
      _hoisted_7,
      _createTextVNode(" Service Mail: "),
      _hoisted_8
    ])
  ]))
}